import { PhraseBankSection } from "..";

export const locationCannotLocate: PhraseBankSection = [
  // 'Searching for location...', this one is used on the button, don't add it here
  `Where's the function?`,
  'Where are you bro?',
  'Where you at?',
  `Tryna find you bro...`,
];

export const locationWaitingForWeather: PhraseBankSection = [
  `Checking barometer...`,
  `Smelling the wind...`,
  `Holding finger in the air...`,
  `Checking thermometer...`,
];
